import React from "react";
import { ShieldCheck, Search, Bug, Wrench } from "lucide-react";
import { useTranslation } from "react-i18next";

const features = [
    {
        icon: Search,
        titleKey: "appPreview.codeScanFeatureDetect",
        titleFallback: "Detect Vulnerabilities",
        descKey: "appPreview.codeScanFeatureDetectDesc",
        descFallback: "Automatically scan your app code for security issues like XSS, injection flaws, and insecure data handling.",
    },
    {
        icon: Bug,
        titleKey: "appPreview.codeScanFeatureSeverity",
        titleFallback: "Severity Classification",
        descKey: "appPreview.codeScanFeatureSeverityDesc",
        descFallback: "Findings are categorized by severity (Error, Warning, Info) so you can prioritize the most critical issues first.",
    },
    {
        icon: Wrench,
        titleKey: "appPreview.codeScanFeatureRemediation",
        titleFallback: "Remediation Guidance",
        descKey: "appPreview.codeScanFeatureRemediationDesc",
        descFallback: "Each finding includes actionable remediation steps to help you fix issues quickly and confidently.",
    },
];

function CodeScanExplainer({ hasScanned }) {
    const { t } = useTranslation();

    return (
        <div className="p-6 space-y-6">
            <div className="text-center space-y-2">
                <ShieldCheck className="w-10 h-10 text-blue-500 mx-auto" />
                <h3 className="text-base font-semibold text-gray-900">
                    {hasScanned
                        ? t("appPreview.codeScanCleanTitle") || "No Issues Found"
                        : t("appPreview.codeScanExplainerTitle") || "Security Code Scanning"}
                </h3>
                <p className="text-sm text-gray-500 max-w-md mx-auto">
                    {hasScanned
                        ? t("appPreview.codeScanCleanDesc") || "Your code passed all security checks. Run a scan again anytime after making changes."
                        : t("appPreview.codeScanExplainerDesc") || "Scan your app's source code for security vulnerabilities using Semgrep, an industry-leading static analysis tool. Scans run against your selected environment."}
                </p>
            </div>
            <div className="space-y-4 max-w-md mx-auto">
                {features.map((feature) => (
                    <div key={feature.titleKey} className="flex gap-3">
                        <feature.icon className="w-5 h-5 text-blue-500 mt-0.5 shrink-0" />
                        <div>
                            <p className="text-sm font-medium text-gray-800">
                                {t(feature.titleKey) || feature.titleFallback}
                            </p>
                            <p className="text-xs text-gray-500">
                                {t(feature.descKey) || feature.descFallback}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default React.memo(CodeScanExplainer);
